import { User } from '@src/entities/User/ui/components/User';
import { Button } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Link } from '@uhg-abyss/web/ui/Link';
import { isUndefined } from 'lodash';
import React, { useEffect, useState } from 'react';

/**
 * Button: AnalyzeRisks
 *
 * Button which when clicked will open the Risk Analysis screen with the supplied entrance criteria.
 *
 * @param actionPath
 * @param criteria
 * @param variant
 * @returns {Element}
 * @constructor
 */
export function AnalyzeRisks({ actionPath = {}, criteria = {}, variant = 'button' }) {
  const router = useRouter();

  const [theCriteria, setTheCriteria] = useState(criteria);

  /**
   * set filters from action path
   */
  useEffect(() => {
    if (!isUndefined(actionPath)) {
      if (actionPath?.manualAssociation === true) {
        setTheCriteria({
          entrance: {
            additional: [
              {
                column: 'ACTION_PATH_ID',
                condition: 'ANY',
                value: [actionPath?.id],
              },
            ],
          },
        });
      }

      if (actionPath?.manualAssociation === false) {
        setTheCriteria(actionPath?.criteria);
      }
    }
  }, [actionPath]);

  return (
    <ErrorHandler location="src/features/RiskAnalysis/components/buttons/AnalyzeRisks/AnalyzeRisks.jsx">
      <User.Capability attributes={['navigate']} resource="Analysis:RiskAnalysis">
        {variant === 'button' && (
          <Button
            before={<IconSymbol icon="bar_chart" variant="outlined" />}
            data-testid="analyze-risks-button"
            onClick={async () => {
              const encoded = Buffer.from(JSON.stringify({ criteria: theCriteria })).toString('base64');
              router?.navigate(`/analysis/risk-analysis/${encoded}`);
            }}
            variant="solid"
          >
            Analyze Risks
          </Button>
        )}
        {variant === 'link' && (
          <Link
            before={<IconSymbol icon="bar_chart" variant="outlined" />}
            data-testid="analyze-risks-link"
            href="/analysis/risk-analysis"
            onClick={async (event) => {
              event?.preventDefault();
              const encoded = Buffer.from(JSON.stringify({ criteria: theCriteria })).toString('base64');
              router?.navigate(`/analysis/risk-analysis/${encoded}`);
            }}
          >
            Analyze Risks
          </Link>
        )}
      </User.Capability>
    </ErrorHandler>
  );
}
